import { AuthActions } from "../auth/actions";
import { UNSET_AUTH } from "../auth/constants";
import { FavouriteAction } from "./actions";
import {
  ADD_TO_FAVOURITES_SUCCESS,
  FETCH_FAVOURITES,
  FETCH_FAVOURITES_SUCCESS,
  REMOVE_FROM_FAVOURITES_SUCCESS,
} from "./constants";

const initialState: FavouriteState = {
  loading: false,
  error: false,
  favourites: [],
};

export const favouriteReducer = (
  state = initialState,
  action: FavouriteAction | AuthActions
): FavouriteState => {
  switch (action.type) {
    case ADD_TO_FAVOURITES_SUCCESS:
    case REMOVE_FROM_FAVOURITES_SUCCESS:
      return {
        ...state,
        error: false,
        favourites: action.favourites,
      };

    case FETCH_FAVOURITES:
      return {
        ...state,
        loading: true,
      };

    case FETCH_FAVOURITES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        favourites: action.favourites,
      };

    case UNSET_AUTH:
      return {
        ...state,
        favourites: [],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/favourites/reducer.ts